<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.servers')}`">
              <div class="v-table">
                <TableServer type="servers" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-server')}`">
              <ServerForm v-if="spawnerAdminSchemas.forms['Server']" />
            </b-tab>
            <b-tab
              v-if="serverId !== null && adminServer.id > 0"
              :title="`${this.$i18n.t('JSON.server')}#${serverId}`"
            >
              <ServerForm
                v-if="spawnerAdminSchemas.forms['Server']"
                :server="adminServer"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
    ServerForm: () => import('@/components/admin/spawner/modals/forms/ServerForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    serverId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      adminServer: (state) => state.adminServer.adminServer,
    }),

    modalId() {
      return 'server';
    },
  },

  watch: {
    serverId(newValue) {
      if (newValue !== null) {
        this.loadSpawnerAdminServer();
      }
    },
  },

  methods: {
    ...mapActions(['getSpawnerAdminServer']),

    async loadSpawnerAdminServer() {
      try {
        await this.getSpawnerAdminServer({
          params: {
            tid: this.serverId,
          },
        });

        // console.log('server', this.server);

        // success
        // console.log('success loading server!');
      } catch (error) {
        // error
        // console.log('error loading server!');
      }
    },

    onOpened() {
      if (this.serverId !== null) {
        this.loadSpawnerAdminServer();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
